import { Button } from '@/components/shared/button/Button';
import { TSCard } from '@/components/shared/card/Card';
import { ApprovalState } from '@/services/gql/graphql.generated';
import { strings } from '@/services/translation/strings';
import { FunctionComponent } from 'react';
import { FiX } from 'react-icons/fi';

interface MyRequestAlertCardProps {
  status: ApprovalState;
  message: string;
  onView: () => void;
  onDismiss?: () => void;
}

const statusStyles: Partial<Record<ApprovalState, string>> = {
  [ApprovalState.Requested]: '',
  [ApprovalState.Approved]: 'bg-green-100 border-green-300 text-green-800',
  [ApprovalState.Rejected]: 'bg-red-100 border-red-300 text-red-800',
  [ApprovalState.CancelledByManager]: 'bg-red-100 border-red-300 text-red-800'
};

const MyRequestAlertCard: FunctionComponent<MyRequestAlertCardProps> = ({ status, message, onView, onDismiss }) => {
  return (
    <TSCard className={`flex items-center justify-between space-x-2 px-6 py-4 ${statusStyles[status]}`}>
      <p className="font-semibold">{message}</p>

      <div className="flex space-x-2">
        <Button onClick={onView}>{strings.common.view}</Button>

        {onDismiss && (
          <Button onClick={onDismiss}>
            <FiX className="h-5 w-5" />
          </Button>
        )}
      </div>
    </TSCard>
  );
};

export default MyRequestAlertCard;
